
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Search, ClipboardList } from 'lucide-react';

export function EmptyState() {
  return (
    <Card className="p-8 text-center">
      <div className="flex justify-center mb-4">
        <ClipboardList className="h-12 w-12 text-grandpal-green" />
      </div>
      <h3 className="font-medium text-lg mb-2">No nursing home leads yet</h3>
      <p className="text-gray-600 mb-6">
        Start by browsing nursing homes and expressing interest to add them to your leads list
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button asChild className="bg-grandpal-green hover:bg-grandpal-green/90">
          <a href="/nursing-homes">
            <Search className="mr-2 h-4 w-4" />
            Browse Nursing Homes
          </a>
        </Button>
        <Button asChild variant="outline">
          <a href="/waitlist">
            <ClipboardList className="mr-2 h-4 w-4" />
            Join Waitlist
          </a>
        </Button>
      </div>
    </Card>
  );
}
